<template>
  <div>
    <div
      :for="name"
      class="checkbox-wrapper"
      @keyup.enter="onKeyboard"
      @keypress.space.prevent="onKeyboard"
      tabindex="0"
    >
      <input
        :checked="value"
        @change="onClick"
        type="checkbox"
        @invalid="onInvalid"
        :id="name"
        :name="name"
        :required="required"
        :disabled="disabled"
        ref="input"
        :aria-errormessage="error ? 'error-message' : undefined"
        data-checkbox-input
      />
      <label :for="name">
        <div class="checkbox nu-bg-gray-050" :class="{ 'nu-text-utility-disabled': disabled }" >
          <nucleus-icon  name="checkmark" class="checkmark nu-font-xl nu-text-utility-selected-1" />
        </div>
        <div v-if="!linkLabel" :for="name" v-html="label" data-checkbox-label></div>
      </label>
      <Tooltip 
        v-if="this.tooltipContent && this.tooltipContent.tooltipHeader && this.tooltipContent.tooltipDescription" 
        :content="tooltipContent"
        :maxWidth="'450px'"
        variantType="standard"
      />
      <button data-checkbox-link-label  @click="this.$emit('linkLabelClick')" v-if="linkLabel" v-html="label" :disabled="disabled" :class="{ 'nu-text-utility-disabled': disabled, 'link':!disabled }"></button>
    </div>
    <div v-if="error" id="error-message" class="error-text">
      <img src="@/assets/icons/warning.svg" alt="warning icon" v-svg-inline />
      <span class="nu-b-utility-error">{{ errorMessage }}</span>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-warning-comments
// TODO: When using this component, the click handler must preceed the value in the properties
// Why? iono.

// import formatting from "@/mixins/formatting-mixin";
// import FormatterComposable from "@/composables/FormatterComposable";
import Tooltip from "@/components/common-components/Tooltip.vue";
export default {
  name: "check-box",
  props: ["value", "label", "tooltipContent", "name", "required", "disabled", "errorMessage", "linkLabel", "linkLabelClickHandler"],
  components: { 
    Tooltip, 
  },
  data() {
    return {
      error: false
    };
  },
  methods: {
    onKeyboard() {
      if (this.disabled) return;
      this.$emit("click", !this.value);
      this.error = false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onClick(event) {
      this.$emit("click", !this.value);
      this.error = false;
    },
    makeKebabCase(idStr) {
      return this.toKebabCase(idStr);
    },
    onInvalid() {
      this.error = true;
      // this.$analytics.sendActionEvent(
      //   this.$route.name,
      //   `${this.$analytics.analyticsEvents.InputError}-${this.toKebabCase(this.name)}`,
      //   {
      //     component: this.$options.name,
      //     errorMessage: "Required field not entered",
      //     invalidFields: [{ fieldName: this.name, value: this.value }]
      //   }
      // );
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "@/scss/mfe/checkbox.scss";
</style>
